<!-- Modals -->

<!-- Delete modal -->
<ui-dialog
    size="small"
    [open]="isDeleteModalOpen"
    header="{{ 'settings.custom-fields.deleteCurrentFieldname' | translate: { name: currentField?.name } }}"
    [primaryButtonLabel]="'delete' | translate"
    (primaryButtonPressed)="onDelete()"
    [primaryButtonType]="'danger'"
    [secondaryButtonLabel]="'cancel' | translate"
    (secondaryButtonPressed)="isDeleteModalOpen = false"
    (closing)="isDeleteModalOpen = false"
>
    <div *ngIf="currentField?.assignedEmployeesCount > 0; else noAssignments">
        <p>
            {{
                'settings.custom-fields.deleteAssociatedDataNotice'
                    | translate: { numberOfEmployees: currentField?.assignedEmployeesCount }
            }}
        </p>
        <p>{{ 'settings.custom-fields.saveDataBeforeDeleteNotice' | translate }}</p>
    </div>
    <ng-template #noAssignments> {{ 'settings.custom-fields.noAssignment' | translate }} </ng-template>
</ui-dialog>

<!-- Body -->
<div class="page-container" [class.loading]="isLoading">
    <app-header title="{{ 'settings.settings' | translate }}" [menuService]="settingsMenuService">
        <div class="buttons" *ngIf="!fieldsIndexTable.isEmpty">
            <ui-button type="primary" routerLink="create">
                <mat-icon svgIcon="plus"></mat-icon>{{ 'settings.custom-fields.createCustomField' | translate }}
            </ui-button>
        </div>
    </app-header>

    <div *ngIf="!fieldsIndexTable.isEmpty; else emptyState">
        <app-table [table]="fieldsIndexTable" (menuItemSelected)="onTableMenuEvent($event)"></app-table>
    </div>

    <ng-template #emptyState>
        <div class="ui segment">
            <app-empty-state
                class="empty-state"
                label="{{ 'settings.custom-fields.youHaveNotCreatedAnyCustomFields' | translate }}"
            ></app-empty-state>

            <div class="ui centered create-custom-field-button">
                <ui-button type="primary" routerLink="create">
                    <mat-icon svgIcon="plus"></mat-icon>{{ 'settings.custom-fields.createCustomField' | translate }}
                </ui-button>
            </div>
        </div>
    </ng-template>
</div>
